import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#root");

if (!root) {
  throw new Error("JarLab could not find its application root.");
}

document.documentElement.style.setProperty(
  "--font-geist-sans",
  '"Inter", "Segoe UI", Arial, sans-serif',
);
document.documentElement.style.setProperty(
  "--font-geist-mono",
  '"JetBrains Mono", "Cascadia Code", Consolas, monospace',
);

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
